<template>
    <div    class="flex justify-around">
        <div    class="w-3/5 grid-cols-12">
            <!-- List of links that should be shown -->
            <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-5 md:grid-cols-2">
                <!-- Grab each links -->
                <template   v-for="link in links">
                    <li     v-if="canSeeLink(link)"
                            class="col-span-1">
                        <!-- Link to page -->
                        <setting-page-link-with-icon    :href="link.link"
                                                        :icon="link.icon"
                                                        :text="link.text"
                                                        :color="link.color"
                        ></setting-page-link-with-icon>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SettingPageLinkWithIcon from "@/components/SonicuSidebar/SettingPageLinkWithIcon.vue";
import {SidebarLinksPageMixin} from "@/mixins/SidebarLinksPageMixin";

// Purple marks pages only engineers can open. UI Tests stays the default blue because UI testers see it too.
const ENGINEERING_ONLY_COLOR = 'bg-purple-600'

export default {
    name: "EngineeringLinksPage",
    mixins: [SonicuCoreMixin, iconNamesMixin, SidebarLinksPageMixin],
    components: {SettingPageLinkWithIcon},
    emits: [],
    props: {},
    data() {
        return {
            links: [
                {
                    text: 'Roles',
                    link: '/SonicuTools/Roles',
                    permission: 'read_roles',
                    show: () => {
                        return this.isEngineer
                    },
                    icon: 'icon-group-work',
                    color: ENGINEERING_ONLY_COLOR,
                },
                {
                    text: 'Permissions',
                    link: '/SonicuTools/Permissions',
                    permission: 'read_permissions',
                    show: () => {
                        return this.isEngineer
                    },
                    icon: 'icon-user-lock',
                    color: ENGINEERING_ONLY_COLOR,
                },
                {
                    text: 'Deleted Companies',
                    link: '/SonicuTools/deleted-companies',
                    permission: 'delete_companies',
                    show: () => {
                        return this.isEngineer
                    },
                    icon: 'icon-city',
                    color: ENGINEERING_ONLY_COLOR,
                },
                {
                    text: 'Scripts Index',
                    link: '/scripts',
                    permission: 'run_scripts',
                    // The link will only render if the user has access to the scripts.
                    show: () => {
                        return this.hasScriptAccess
                    },
                    icon: 'icon-cli',
                    color: ENGINEERING_ONLY_COLOR,
                },
                {
                    text: 'Add Banner',
                    link: '/SonicuTools/banners',
                    permission: 'do_anything',
                    show: () => {
                        return this.isEngineer
                    },
                    icon: 'icon-bubble',
                    color: ENGINEERING_ONLY_COLOR,
                },
                {
                    text: 'UI Tests',
                    link: '/engineering/ui-tests',
                    show: () => {
                        return this.hasUiTestAccess
                    },
                    icon: 'icon-clipboard-check',
                }
            ],
            isEngineer: false,
            hasScriptAccess: false,
            hasUiTestAccess: false,
        }
    },
    created() {
        this.links = this.parseCompanyLinks(this.links)
    },
    mounted() {
        axios.get('/api-internal/is-sonicu-engineer'
        ).then(response => {
            let data = response.data
            this.isEngineer = data.isEngineer
            this.hasScriptAccess = data.hasScriptAccess
            this.hasUiTestAccess = data.hasUiTestAccess
        })
    },
    methods: {

    },
    computed: {

    },
    watch: {},
}
</script>

<style scoped>

</style>